// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuProfile{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuProfile_form{
    --formGap: 22px;
    display: flex;
    flex-wrap: wrap;
    gap: var(--formGap);
}

.SideMenuProfile_buttons{
    display: flex;
    align-items: flex-end;
    height: 100%;
    justify-content: flex-end;
    gap: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuProfile.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,yBAAyB;IACzB,SAAS;AACb","sourcesContent":[".SideMenuProfile{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuProfile_form{\n    --formGap: 22px;\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--formGap);\n}\n\n.SideMenuProfile_buttons{\n    display: flex;\n    align-items: flex-end;\n    height: 100%;\n    justify-content: flex-end;\n    gap: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
